/** Non-native platforms: no FCM / CallKeep. */
export function AppNativeCallListeners(): null {
  return null;
}
